import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 8, height: 14, viewBox: "0 0 8 14", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m12.393 4.281-.862.859 6.163 6.141-6.163 6.141.862.859 6.594-6.571.412-.429-.412-.429z", "data-name": "icon_arrow_right", transform: "translate(-11.531 -4.281)", fill: "#98a9bc" }));
const ForwardRef = forwardRef(SvgIconArrowRight);
export { ForwardRef as ReactComponent };
